import React from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";

import DupontButton from "../DupontButton";
import { OverlayLoader } from "../PageLoading";

import "./index.scss";

export const DIALOG_ACTIONS = {
  CONFIRM: "CONFIRM",
  CANCEL: "CANCEL",
  RESET: "RESET",
  UNSHARE: "UNSHARE",
};

export default function DupontDialog(props) {
  const { t } = useTranslation();
  const {
    open,
    onClose,
    title,
    customTitle,
    confirmBtnText,
    unShareBtnText,
    cancelBtn = true,
    resetBtnText,
    customClass,
    confirmDisabled,
    unShareDisabled,
    type,
    subTitle,
    isOverlayLoader,
    maxWidth,
    minWidth,
    customHeight = "450px",
  } = props;

  const cancelBtnText = props.cancelBtnText || t("ValueStrings.cancel");
  const btnColor = type === "primary" ? "white" : type;

  const closeBtnHandler = () => onClose(DIALOG_ACTIONS.CANCEL);
  const confirmBtnHandler = () => onClose(DIALOG_ACTIONS.CONFIRM);
  const unShareBtnHandler = () => onClose(DIALOG_ACTIONS.UNSHARE);
  const resetBtnHandler = () => onClose(DIALOG_ACTIONS.RESET);

  const getDialogTheme = () => {
    const dialogType = type || "default";
    return `dupont-dialog--${dialogType}`;
  };

  return (
    <Dialog
      onClose={closeBtnHandler}
      aria-labelledby={title}
      open={open}
      maxWidth={maxWidth}
      disableBackdropClick={true}
      PaperProps={{
        style: {
          minWidth: minWidth,
        },
      }}
    >
      {isOverlayLoader && <OverlayLoader customHeight={customHeight} />}
      <div className={`dupont-dialog ${getDialogTheme()} ${customClass || ""}`}>
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="dupont-dialog__title"> {title}</div>
        </header>
        {customTitle && <div>{customTitle}</div>}
        {subTitle && <div className="dupont-dialog__subTitle">{subTitle}</div>}
        <main className={`dupont-dialog__body`}> {props.children} </main>
        <footer className="dupont-dialog__footer">
          {cancelBtn && (
            <DupontButton
              id="cancelBtn"
              type={"secondary"}
              color={btnColor}
              onClick={closeBtnHandler}
              customClass="dupont-dialog__footer--btn-spacing"
            >
              {cancelBtnText}
            </DupontButton>
          )}
          {resetBtnText && (
            <DupontButton
              id="resetBtn"
              type={"secondary"}
              color={btnColor}
              onClick={resetBtnHandler}
              customClass="dupont-dialog__footer--btn-spacing"
            >
              {resetBtnText}
            </DupontButton>
          )}
          {unShareBtnText && (
            <DupontButton
              id="submitBtn"
              type={"primary"}
              color={btnColor}
              disabled={unShareDisabled}
              onClick={unShareBtnHandler}
              customClass="dupont-dialog__footer--confirm-btn margin-right-10 "
            >
              {unShareBtnText}
            </DupontButton>
          )}
          {confirmBtnText && (
            <DupontButton
              id="submitBtn"
              type={"primary"}
              color={btnColor}
              disabled={confirmDisabled}
              onClick={confirmBtnHandler}
              customClass="dupont-dialog__footer--confirm-btn"
            >
              {confirmBtnText}
            </DupontButton>
          )}
        </footer>
      </div>
    </Dialog>
  );
}
